// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.flag-icon[data-v-70d8f726] {\n  width: 26px !important;\n  line-height: 20px !important;\n}\n", ""]);
// Exports
module.exports = exports;
